import React from 'react';
import { useHistory } from 'react-router-dom';
import { Menu } from 'antd';
import { MenuInfo } from 'rc-menu/lib/interface';
import { ERoutesFranchiseePrivate, RoutesCirPrefix } from 'common/models/routesModel';
import { isCirEnabled } from 'common/config/env.config';
import { ArrowSquareOut } from 'common/svg';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { logout } from 'app/store/reducers/auth.reducer';
import { EUserRole, EUserRoleText } from 'entities/User/User.models';

interface IComponentProps {
  mobile?: boolean;
  closeMenu?: () => void;
}

export const HeaderMenu: React.FC<IComponentProps> = ({ mobile, closeMenu = () => {} }) => {
  // ---> Leave as is. Just to update history and path on-the-go
  useAppSelector((state) => state.router);
  // <---
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { authModel, authUser } = useAppSelector((state) => state.auth);
  const authorized = authModel && Object.keys(authModel).length !== 0;
  const visibleLogout = authorized && mobile;
  const path = history.location.pathname;
  const currentPath = path.split(/(^\/[a-z-A-Z]*)/)[1];
  const showLogo = !mobile;
  const mobileClass = mobile ? 'header-franchisee-menu_mobile' : '';
  const mode = mobile ? 'vertical' : 'horizontal';
  const isSalesOp = authUser?.role === EUserRole.SalesOps;
  const isFranchisee = authUser?.role === EUserRole.Franchisee;
  const logoRole = isSalesOp ? EUserRoleText.SalesOps : EUserRoleText.Franchisee;

  const onLogout = () => {
    closeMenu();
    dispatch(logout());
  };

  const redirect = (e: MenuInfo) => {
    closeMenu();
    history.push(e.key.toString());
  };

  const redirectToMain = () => {
    closeMenu();
    history.push(ERoutesFranchiseePrivate.StoreList);
  };

  const redirectToCirPortal = () => {
    closeMenu();
    history.push(`${RoutesCirPrefix}${ERoutesFranchiseePrivate.GeneratePO}`);
  };

  return (
    <Menu selectedKeys={[currentPath]} mode={mode} className={`header-franchisee-menu ${mobileClass}`}>
      {showLogo && (
        <Menu.Item key="logo" onClick={redirectToMain}>
          <span className="header-franchisee__title">MB</span>
          <span className="header-franchisee__title_role"> — {logoRole}</span>
        </Menu.Item>
      )}

      <Menu.Item
        key={ERoutesFranchiseePrivate.StoreList}
        onClick={redirect}
        className="header-franchisee-menu__activilable-item"
      >
        Stores
      </Menu.Item>
      <Menu.Item
        key={ERoutesFranchiseePrivate.Statistics}
        onClick={redirect}
        className="header-franchisee-menu__activilable-item"
      >
        Statistics
      </Menu.Item>
      {isFranchisee && (
        <Menu.Item
          key={ERoutesFranchiseePrivate.APIKeys}
          onClick={redirect}
          className="header-franchisee-menu__activilable-item"
        >
          API Keys
        </Menu.Item>
      )}
      <Menu.Item
        key={ERoutesFranchiseePrivate.PasswordAndSecurity}
        onClick={redirect}
        className="header-franchisee-menu__activilable-item"
      >
        Password And Security
      </Menu.Item>

      {isFranchisee && isCirEnabled && (
        <Menu.Item onClick={redirectToCirPortal} className="header-franchisee-menu__activilable-item">
          CIR Portal
          <ArrowSquareOut className="mb-1 ml-3 icon-white" />
        </Menu.Item>
      )}

      {visibleLogout && (
        <Menu.Item key="logout" onClick={onLogout} className="header-franchisee-menu__activilable-item">
          Log out
        </Menu.Item>
      )}
    </Menu>
  );
};
